import { render, staticRenderFns } from "./OrganInfectionList.vue?vue&type=template&id=08ca0fc1"
import script from "./OrganInfectionList.vue?vue&type=script&lang=js"
export * from "./OrganInfectionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports